import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {ListDivider} from 'rmwc/List';
import StarRatings from 'react-star-ratings';
import TPOUserIndividualResource from './TPOUserIndividualResource';

class TPOUserResourcePage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
                resourceDetails: []
    		}
    	}
    }

    componentDidMount(){
        let data = Object.assign({}, this.state.data)

        return api.renderUserTPOResource(this.props.user.accessToken)
        .then((result) => {
            data.resourceDetails = result.data
            this.setState({data: data})
        })
    }

    render () {
        let resourceComponent

        if(this.state.data.resourceDetails.length>0){
            resourceComponent = (
                <div>
                    {this.state.data.resourceDetails.map(function(resource){
                        return(
                            <TPOUserIndividualResource tpoResourceId = {resource.id}
                                tpoResourceName = {resource.name}
                                tpoResourceLink = {resource.resource_link}
                                tpoResourceAuthor = {resource.author}
                                tpoResourceDescription = {resource.description} />
                        )
                    })}
                </div>
            )
        }
        else {
            resourceComponent = (
                <div>
                    <Typography use="subtitle2" align="left"> There are no TPO Resources. </Typography>
                </div>
            )
        }

    	return (
            <div>
        		<Grid>
                    <GridCell span="12">
                        <Card style={{padding: '25px'}}>
                            <Typography use="headline5"> TPO Learning Resources </Typography>
                        </Card>
                    </GridCell>
                    <GridCell span="11">
                        <Card style={{padding: '25px'}}>
                            {resourceComponent}
                        </Card>
                    </GridCell>
                </Grid>
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPOUserResourcePage);


// WEBPACK FOOTER //
// ./src/views/roadmap/TPOUserResourcePage.jsx